import {Box, Button, Grid, Modal, Typography} from "@mui/material";
import React, {useContext, useEffect} from "react";
import {AppContext} from "@/utils/appContext";
import {useTranslation} from "react-i18next";
import {makeStyles} from "tss-react/mui";
import alarm from '../assets/icons/alarm.svg';
import {useCountdownDate} from "@/hooks/use-countdown";
import {deleteAllCart, getExtraTime} from "@/utils/requests";
import {useGetCart} from "@/api/cart";

const ModalCartExpire = () => {


  const appContext = useContext(AppContext);

  if (!appContext.cartExpireAt) return (<></>);


  const {t} = useTranslation();
  const {classes} = useStyles();
  const {cartMutate} = useGetCart(appContext.userId);



  const getExtraTimeToBook = async () => {
    appContext.setBackdropIsOpen(true)
    await getExtraTime(appContext.userId)
    await cartMutate()
    appContext.setOpenModalCartExpiring(false);
    appContext.setBackdropIsOpen(false)
  };

  const deleteCart = async () => {
    appContext.setBackdropIsOpen(true)
    try {
      await deleteAllCart(appContext.userId);
      await cartMutate()
    } catch (e) {
      console.error(e);
    } finally {
      appContext.setOpenModalCartExpiring(false);
      appContext.setBackdropIsOpen(false)
    }


  };

  const {days, hours, minutes, seconds, distance, timer} = useCountdownDate(appContext.cartExpireAt)

  useEffect(() => {

    if (minutes === '00' && seconds === '59') {
      appContext.setOpenModalCartExpiring(true);
    }

    if (seconds.includes('-') && appContext.openModalCartExpiring) {
      appContext.setOpenModalCartExpiring(false);
    }
  }, [seconds]);

  return appContext.openModalCartExpiring ? (
    <Modal
      open={appContext.openModalCartExpiring}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Grid
        container
        alignItems={'center'}
        justifyContent={'space-evenly'}
        direction={'row'}
        className={classes.root}
        p={3}>
        <Grid item xs={12}>
          <Box className={classes.iconContainer}>
            <img src={alarm} width={42} height={42} alt={''}/>
          </Box>
        </Grid>
        <Grid item xs={12} mt={3}>
          <Typography variant={'h4'} component={'h4'}>{t('Il_carrello_sta_per_scadere')}</Typography>
          <Typography variant={'body1'} component={'p'} mt={1}>{t('Stai_ancora_cercando?')}</Typography>
        </Grid>

        <Grid
          container
          alignItems={'center'}
          justifyContent={'space-evenly'}
          direction={'row'}
          spacing={3}
          mt={3}
        >
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant={'contained'} color={'primary'} className={classes.secondaryBtn}
                    onClick={async () => await deleteCart()}>
              {t('svuota_carrello')} ({seconds})
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant={'contained'} color={'primary'} className={classes.mainBtn}
                    onClick={async () => await getExtraTimeToBook()}>
              {t('sto_ancora_cercando')}
            </Button>
          </Grid>
        </Grid>

      </Grid>
    </Modal>
  ) : (<></>)
};
export default ModalCartExpire;

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      width: 560,
      padding: 50,
      left: 0,
      top: '50%',
      position: 'absolute',
      right: 0,
      margin: 'auto',
      backgroundColor: 'white',
      transform: 'translate(0,-50%)',
      textAlign: 'center',
      '.MuiListItem-root': {
        alignItems: 'center',
        cursor: 'pointer'
      },
      '.MuiAvatar-root': {
        backgroundColor: 'transparent'
      },
      [theme.breakpoints.down('sm')]: {
        width: '85%',
        padding: 30,
        h4: {
          fontSize: 18
        },
        p: {
          lineHeight: '20px'
        }
      }
    },
    iconContainer: {
      width: 90,
      height: 90,
      textAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#FFEE00',
      borderRadius: '50%',
      margin: 'auto',
    },
    secondaryBtn: {
      border: '1px solid #B32D24',
      backgroundColor: '#B32D24',
      padding: '6px 6px!important',
      color: '#FFF',
      '&:hover': {
        backgroundColor: '#B32D24',
      }
    },
    mainBtn: {
      backgroundColor: '#000',
      color: '#FFF',
      '&:hover': {
        backgroundColor: '#000',
      }
    }
  };
});
